import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqItems } from '../data/offer';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white" data-id="element-16" data-mp="1l9o616jt3vko">
      <div className="mx-auto max-w-3xl px-4 pb-16 sm:px-6 sm:pb-20" data-id="element-17" data-mp="1gd7hwcclxh7l">
        <h2 className="font-display text-2xl font-extrabold tracking-tight text-navy-950 sm:text-3xl" data-id="element-18" data-mp="1gaurrbwp40jg">
          Preguntas frecuentes
        </h2>
        <dl className="mt-8 divide-y divide-navy-200 border-t border-navy-200" data-id="element-19" data-mp="292eidgvmggvh">
          {faqItems.map((item, index) => {
          const isOpen = openIndex === index;
          return <div key={item.question} data-id="element-20" data-mp="1z25gbmey8186" data-mpi={index}>
                <dt data-id="element-21" data-mp="1z59pyzb6np68">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-5 text-left font-display text-lg font-bold tracking-tight text-navy-950 transition-colors duration-150 ease-smooth hover:text-navy-600" data-id="element-22" data-mp="sn3g8aizbrj8">
                    {item.question}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-lime-600 transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-23" data-mp="fiyr3x09dy4s" />
                  </button>
                </dt>
                <AnimatePresence initial={false} data-id="element-24" data-mp="bk9h8eefiypw">
                  {isOpen && <motion.dd initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-25" data-mp="3t0hls0d403e5">
                      <p className="pb-5 pr-10 leading-relaxed text-navy-800/80" data-id="element-26" data-mp="1uh4d1l1eukws">{item.answer}</p>
                    </motion.dd>}
                </AnimatePresence>
              </div>;
        })}
        </dl>
      </div>
    </section>;
}